export const DEALER_OPTIN_MODE = {
  ALWAYS: "always",
  HIDE_ON_WAITLIST: "hideOnWaitlist",
  SKIP: "skip",
};

export const getDealerOptInMode = (eventData) => {
  if (eventData?.checkedInLeads || eventData?.capConfig?.leadTrigger === "checkedIn" ||
      eventData?.skipDealerOptIn) return DEALER_OPTIN_MODE.SKIP;
  if (eventData?.hideDealerOptInOnWaitlist) {
    return DEALER_OPTIN_MODE.HIDE_ON_WAITLIST;
  }
  return DEALER_OPTIN_MODE.ALWAYS;
};

export const dealerOptInModeFlags = (mode) => ({
  skipDealerOptIn: mode === DEALER_OPTIN_MODE.SKIP,
  hideDealerOptInOnWaitlist: mode === DEALER_OPTIN_MODE.HIDE_ON_WAITLIST,
});

export const shouldAskDealerOptIn = (eventData, registration = {}) => {
  if (!eventData?.allowPushToCap) return false;
  const mode = getDealerOptInMode(eventData);
  if (mode === DEALER_OPTIN_MODE.SKIP) return false;
  if (
    mode === DEALER_OPTIN_MODE.HIDE_ON_WAITLIST &&
    registration?.status === "Waitlist"
  ) {
    return false;
  }
  return true;
};

export const clearDealerOptInIfHidden = (eventData, registration = {}) => {
  if (shouldAskDealerOptIn(eventData, registration)) {
    return registration;
  }
  if (registration?.dealer_optin == null) {
    return registration;
  }
  return { ...registration, dealer_optin: null };
};
